import { userRoles } from "../../constant";
import { useUser } from "../../services/user-context";
import { ManagerDashboard } from "./ManagerDashboard";

export function TeamDashboard() {
  const { userInfo } = useUser() as any;
  const role = userInfo?.role;
  if ([userRoles.Trainer, userRoles.Manager, userRoles.Admin].includes(role)) {
    return <ManagerDashboard />;
  }
  return null;
}
